import styled from "styled-components";
import { media } from "../../common/media";

const DropdownContainer = styled.section`
  a,
  li {
    transition: all 0.6s ease 0s;
    color: #000;
    font-size: 12px;
    &:hover {
      color: #1EBEC8;
    }
  }

  img {
    width: 50px;
    height: 40px;
    float: left;
    margin-right: 10px;
    width: 100%;
    max-width: 130px;
    height: 74px;
  }

  p {
    color: #f04f37;
    text-align: left;
    font-size: 12px;
    padding-right: 0;
    margin-top: 5px;
    color: #333;
    font-size: 14px;
  }

  .drop-mini-cart {
    .sc {
      max-height: 300px !important;
      ${media.desktop`
        display: none;
      `}
    }
    i {
      font-size: 9px;
      padding: 1px !important;
    }
  }
  .sc {
    padding: 10px;
    max-height: 200px;
    overflow-y: auto;
  }

  .mini-cart-item {
    position: relative;
    min-height: 100px;
    border-bottom: 1px solid rgb(204, 204, 204);
    margin-top: 10px;
    button {
      background: none;
      border-radius: 50% !important;
      border: 0;
      transition: all 0.6s ease 0s;
      cursor: pointer;
      float: right;
      margin: 0 10px;
      width: 24px;
      height: 24px;
      &:hover {
        background: #e0e6ef;
      }
      svg {
        font-size: 16px;
        color: #000;
      }
    }
    img {
      float: left;
      margin-right: 10px;
      width: 100%;
      max-width: 130px;
      height: 74px;
      background: rgb(244, 244, 244);
    }
    h5,
    p {
      font-size: 13px;
    }
    h5:hover {
      color: #1EBEC8;
    }
  }
  .playlist-count {
    margin-left: 20px;
    span {
      background: #1EBEC8;
      color: #fff;
    }
  }
  .materialUi__dropdown {
    .materialUi__dropdown--toggle {
      height: 36px;
      &.materialUi__dropdown--toggle--active {
        color: #1EBEC8 !important;
      }
    }
    .materialUi__dropdown--menu {
      margin-top: 21px;
    }
  }
`;

export default DropdownContainer;
